import React, { Fragment, useState } from "react";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import ModalActions from "components/ModalActions";
import HoverIconButton from "components/HoverIconButton";

const DocsInfoButton = ({ icon = "help", slides, url }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Fragment>
      <HoverIconButton type={icon} onClick={() => setShowModal(true)} />
      {showModal && (
        <Modal showModal={showModal} onClose={() => setShowModal(false)}>
          <ModalContent slides={slides}>
            {() => (
              <div className="w-100 pa3">
                <div className="pl2 pb4 center">
                  <a
                    target="_blank"
                    className="f6 link color-primary fw5 link__decoration--hover"
                    href={url}
                  >
                    Learn more
                  </a>
                </div>
                <ModalActions
                  actions={[
                    {
                      cta: "Close",
                      onClick: () => {
                        setShowModal(false);
                      }
                    }
                  ]}
                />
              </div>
            )}
          </ModalContent>
        </Modal>
      )}
    </Fragment>
  );
};

export default DocsInfoButton;
